var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.isAuthenticated)?_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":_vm.login}},[_vm._v(" Log In ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }